module.exports = __webpack_public_path__ + "static/media/027.2843ccb1.jpg";